<template>
  <v-card>
    <v-tabs :value="interCommDiscFactTab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="fetchInterCommDiscFactors()">Factors</v-tab>
      <v-tab v-show="displayFactReviewTab" @click="reviewInterCommDiscFactors()">Factor Info and Rates</v-tab>
      <v-tab v-show="displayRateTab">Rate Info</v-tab>
      <v-tab-item>
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayFactReviewTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
      <v-tab-item v-if="displayRateTab">
        <transition name="slide-x-transition" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import { ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU } from '@/store/types'

export default {
  data() {
    return {
    }
  },
  computed: {
    interCommDiscFactTab() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorTabMenu
    },
    displayFactReviewTab() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorDisplayFactReviewTab
    },
    displayRateTab() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorDisplayRateTab
    },
    interCommDiscFactorProduct() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorProduct
    },
    interCommDiscFactorEffDate() {
      return this.$store.state.adminInter.intermediary.interCommDiscFactorEffDate
    }
  },
  methods: {
    fetchInterCommDiscFactors() {
      const commitData = {
        interCommDiscFactTab: 0,
        displayFactReviewTab: false,
        displayRateTab: false
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
      this.$router.push({ name: 'interCommDiscFactors', params: { inter: this.inter } })
    },
    reviewInterCommDiscFactors() {
      const commitData = {
        interCommDiscFactTab: 1,
        displayFactReviewTab: true,
        displayRateTab: false
      }
      this.$store.commit(ADMININTERMEDIARY_INTERCOMMDISCFACT_TABMENU, commitData)
      this.$router.push({ name: 'interCommDiscFactorReview', params: { product: this.interCommDiscFactorProduct, effectiveDate: this.interCommDiscFactorEffDate } })
    }
  },
  props: {
    inter: {
      type: String,
      default: ''
    }
  },
  created() {
    this.fetchInterCommDiscFactors()
  }
}
</script>

<style lang="scss">
</style>
